import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

const Field = ({ label, children, testId, mono }) => (
  <div className="mb-3">
    <p className="text-[8px] uppercase tracking-wider text-gray-500">{label}</p>
    <p className={`text-[12px] text-gray-900 ${mono ? 'check-mono break-all text-[9px]' : ''}`} data-testid={testId}>{children}</p>
  </div>
);

export const CheckVoucher = ({ data }) => {
  const { check, stub, e_signature: esig } = data;
  return (
    <section className="check-panel check-stub" data-testid="check-voucher-stub">
      <div className="flex justify-between items-baseline border-b-2 border-gray-900 pb-1 mb-4">
        <p className="check-serif font-bold text-[12px]">CHECK VOUCHER &mdash; Detach and retain for your records</p>
        <p className="check-mono text-[10px]">No. {check.check_number} &middot; {stub.date}</p>
      </div>
      <div className="grid grid-cols-[1.4fr_1.4fr_2fr_auto] gap-4">
        <div>
          <Field label="Payee">{check.payee_name}</Field>
          {check.payee_address && <Field label="Payee address">{check.payee_address}</Field>}
          <Field label="Amount" testId="voucher-amount">{check.amount_numeric} ({check.beth_amount})</Field>
          <Field label="Memo">{check.memo || '\u2014'}</Field>
        </div>
        <div>
          <Field label="Barter credit ref.">{stub.barter_credit.reference}</Field>
          <Field label="Current holder">{stub.current_holder}</Field>
          <Field label="Assignable">{stub.assignable ? 'Yes - endorsable to third party' : 'No'}</Field>
          <Field label="Endorsements">{stub.assignment_chain.length - 1}</Field>
        </div>
        <div>
          <Field label={`E-signature (${esig.algorithm}) - ${esig.signer}`} mono testId="voucher-esig-hash">{esig.hash}</Field>
          <Field label="Signed at">{new Date(esig.signed_at).toLocaleString()}</Field>
          <Field label="Sepolia/Mainnet anchor transaction" mono testId="voucher-onchain-hash">{data.onchain_tx_hash || 'Not yet recorded on-chain'}</Field>
          <Field label={`Withdrawing account - ${check.treasury_vault.name}`} mono>{check.treasury_vault.address}</Field>
        </div>
        <div className="text-center" data-testid="voucher-qr-code">
          <QRCodeSVG value={`${window.location.origin}/verify-check/${check.check_number}?${new URLSearchParams({ t: data.claim_token, ...(data.bank_qr ? { v: 'BETHCHK1', ...data.bank_qr } : {}) })}`} size={120} level="Q" marginSize={4} bgColor="#ffffff" fgColor="#000000" />
          <p className="text-[7px] text-gray-600 mt-0.5">Scan: cash out &amp; Etherscan record</p>
        </div>
      </div>
    </section>
  );
};
